import { Link } from "react-router-dom";
import "./style.scss";
import Button from "../Button";

const HeroSection = ({
  backLink = "/",
  backText = "Back to Home",
  title,
  subtitle,
  stats = [],
  icon = null, 
}) => {
  return (
    <section className="hero-section py-5 bg-gradient-hero">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-md-11">
            {/* Back Button */}
            <Link to={backLink}>
            <Button variant="back">
              ← {backText}
            </Button>
            </Link>

            {/* Content */}
            <div className="text-center mb-5">
              {/* Icon */}
              {icon && (
                <div className="d-flex justify-content-center mb-3">
                  <div className="hero-icon bg-gradient-primary rounded-circle">
                    {icon}
                  </div>
                </div>
              )}

              {/* Title */}
              <h1 className="fw-bold text-light mb-3 pt-0">{title}</h1>

              {/* Subtitle */}
              <p className="lead text-light mb-4">{subtitle}</p>

              {/* Stats */}
              <div className="row text-center">
                {stats.map((item, idx) => (
                  <div className="col-md-3 col-6 mb-3" key={idx}>
                    <h3 className="fw-bold text-primary">
                      {item.value}
                    </h3>
                    <small className="text-light">{item.label}</small>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default HeroSection;